export default "__VITE_ASSET__COvPX_cI__"